import React from "react";
import styled from "styled-components";
import { startOAuthLogin } from "@/utils/oauthUtils";
import { fontFamily } from "@/styles/font";

const Login: React.FC = () => {
    /**
     * 카카오 로그인 버튼 클릭 핸들러
     * oauthUtils의 startOAuthLogin 함수를 사용하여 카카오 로그인 인증 시작
     */
    const handleKakaoLogin = () => {
        startOAuthLogin("KAKAO");
    };

    return (
        <LoginContainer>
            <LogoSection>
                <Logo src="/images/soolmoa_logo.png" alt="술모아 로고" />
                <LogoText>전통주를 모아, 나만의 취향 선택</LogoText>
            </LogoSection>

            <LoginButtonsSection>
                <KakaoLoginButton onClick={handleKakaoLogin}>
                    <KakaoIcon />
                    <KakaoLoginText>카카오로 3초만에 시작하기</KakaoLoginText>
                </KakaoLoginButton>
            </LoginButtonsSection>
        </LoginContainer>
    );
};

// 스타일 컴포넌트
const LoginContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; /* 전체 화면 중앙 정렬 */
    width: 100%;
    min-width: 320px;
    max-width: 430px;
    height: calc(100vh - 40px); /* 전체 화면 높이 사용 */
    margin: 0 auto;
    background: #ffffff;
    overflow-x: hidden;
`;
const LogoSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-grow: 1; /* 남은 공간을 자동으로 채움 → 중앙 정렬 */
`;

const Logo = styled.img`
    width: 137px;
    height: 86px;
    object-fit: contain;
    flex: none;
    order: 0;
    flex-grow: 0;
`;

const LogoText = styled.p`
    width: auto;
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 400;
    font-size: clamp(14px, 2.8vw, 18px);
    line-height: 1.5;
    text-align: center;
    color: #000000;
    margin: 0;
    flex: none;
    order: 1;
    flex-grow: 0;
`;

const LoginButtonsSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px;
    gap: 24px;
    width: 100%;
    margin-top: auto; /* 버튼이 화면 하단으로 이동 */
    margin-bottom: 100px; /* 버튼 위치 조정 */
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
    box-sizing: border-box;
`;

const KakaoLoginButton = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 361px;
    height: 54px;
    background: #fae100;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    flex: none;
    order: 0;
    align-self: center;
    flex-grow: 0;
    margin: 0 auto;
`;

const KakaoIcon = styled.div`
    position: absolute;
    width: 24px;
    height: 24px;
    left: 16px;
    top: calc(50% - 12px);

    &:before {
        content: "";
        position: absolute;
        width: 24px;
        height: 24px;
        background-color: transparent;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 3C7.03125 3 3 6.34375 3 10.4062C3 13.0312 4.75 15.3125 7.28125 16.5938L6.5 19.9688C6.5 20.0625 6.5 20.0625 6.59375 20.1562C6.6875 20.25 6.78125 20.25 6.875 20.1562L10.7812 17.5312C11.1875 17.625 11.5938 17.625 12 17.625C16.875 17.625 21 14.375 21 10.3125C21 6.34375 16.9688 3 12 3Z' fill='black'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
    }
`;

const KakaoLoginText = styled.span`
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 700;
    font-size: clamp(14px, 2.8vw, 18px);
    line-height: 1.2;
    text-align: center;
    color: #212121;
`;

export default Login;
